import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AppRouter from "./AppRouter";
import DataProvider from "./dataContext";
import SendTextPage from "./screens/SendTextPage";
import { ROUTE_CONSTANTS } from "./constants/routeConstants";

const { SEND_TEXT_PAGE } = ROUTE_CONSTANTS;

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={SEND_TEXT_PAGE} element={<SendTextPage />} />
        <Route path="/*" element={
          <DataProvider>
            <AppRouter />
          </DataProvider>
        } />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
